import { toast } from 'react-toastify'
import { snapshot } from 'valtio'
import { type RecurringPayment, recurringPaymentProxy } from '../../../../../shared/proxies/recurringPaymentProxy'
import { buildAxiosInstance } from '../../../../../shared/utils/apiUtils'
import { convertFromCentValue } from '../../../../../shared/utils/formattingUtils'

export async function executeRecurringTransactionResume (): Promise<void> {
  const { nextPaymentDate, recurringPayment } = snapshot(recurringPaymentProxy)

  if (!recurringPayment) {
    return
  }

  recurringPaymentProxy.suspendApiCall.loading = true
  recurringPaymentProxy.suspendApiCall.error = null
  try {
    const response = await buildAxiosInstance().post('/api/recurring_payments/resume',
      {
        nextPaymentDate,
        recurringPaymentId: recurringPayment.id
      })

    if (response.data.error) {
      recurringPaymentProxy.suspendApiCall.error = response.data.error
      toast.error('There was an error resuming the payment')
    } else {
      const recentTxn: RecurringPayment = response.data?.data?.recurringPayment ?? {}

      recentTxn.amountCents = convertFromCentValue(recentTxn.amountCents, recentTxn.amountCurrencyType)
      recentTxn.totalAmountChargedCents = convertFromCentValue(recentTxn.totalAmountChargedCents, recentTxn.totalAmountChargedCurrencyType)

      recurringPaymentProxy.recurringPayment = recentTxn
      toast.success('Recurring charge successfully resumed')
    }
  } catch (e) {
    if (e instanceof Error) {
      recurringPaymentProxy.suspendApiCall.error = e.message
      toast.error('There was an error suspending the transaction')
    }
  } finally {
    recurringPaymentProxy.suspendApiCall.loading = false
    recurringPaymentProxy.displayResumeModal = false
    recurringPaymentProxy.nextPaymentDate = null
  }
}
